import { SimpleGrid, Text } from '@chakra-ui/react';

import version from '@/version.json';

export const VersionInfo = () => {
  return (
    <SimpleGrid columns={2} spacing={4}>
      <Text>Build Number</Text>
      <Text fontWeight={700}>{version.VERSION}</Text>
      <Text>Build Date</Text>
      <Text fontWeight={700}>{new Date(version.BUILD_DATE).toLocaleString()}</Text>
      <Text>Commit</Text>
      <Text fontWeight={700}>{version.COMMIT}</Text>
    </SimpleGrid>
  );
}